module.exports = __webpack_public_path__ + "img/T744-B53.8045fe85.jpg";